<div [@habitHeightAnimation]="(this.cantExpand() || this.collapsed()).toString()" class="habit" (click)="collapsed.set(!collapsed())" [class.pointer]="!cantExpand()">
    <div class="d-flex w-100 align-items-center justify-content-between">
        <div class="d-flex align-items-center gap-2">
            <svg-icon [src]="'assets/icons/' + icon() + '.svg'" class="information-icon d-flex align-items-center" />
            <p class="nunito-semibold habit-status">
                {{getHabitStateLabel()}}
            </p>
        </div>
        @if (!cantExpand())
        {
            <svg-icon src="assets/icons/chevron-down.svg" class="collapsed-icon d-flex align-items-center" [class.open]="!collapsed()" />
        }
    </div>
    @if (!cantExpand())
    {
        <div class="d-flex flex-column gap-1 pt-12">
            @if (habit()?.amount)
            {
                <p class="nunito-medium habit-information">
                    {{'PATIENT_TIMELINE_INFORMATION.AMOUNT' | translate}}: {{habit().amount}}
                </p>
            }
            @if (habit()?.since && habit()?.since?.value && habit()?.since?.durationType)
            {
                <p class="nunito-medium habit-information">
                    {{'PATIENT_TIMELINE_INFORMATION.DURATION' | translate}}: {{habit().since.value}} {{getDurationLabel()}}
                </p>
            }
            @if (habit()?.frequency)
            {
                <p class="nunito-medium habit-information">
                    {{'PATIENT_TIMELINE_INFORMATION.FREQUENCY' | translate}}: {{getFrequencyLabel()}}
                </p>
            }
        </div>
    }
</div>
